import React, { useState } from "react";
import { InertiaLink, usePage } from "@inertiajs/inertia-react";
import classNames from "classnames";
import { ChevronDown } from "react-feather";

export function ResultsDropdown({ closeMobileNavigation }) {
  let { url } = usePage();

  const isActive = url.startsWith("/dashboard") || url.startsWith("/inventory");

  const [isOpen, setIsOpen] = useState(isActive);

  const handleToggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className="group mb-2 flex">
        <InertiaLink
          className={classNames(
            "mr-1 flex-1 rounded-sm px-4 py-3 text-[18px] font-bold leading-[130%] lg:group-hover:bg-black",
            {
              "bg-primary group-hover:bg-primary": isActive,
            },
          )}
          href="/dashboard"
          onClick={closeMobileNavigation}
        >
          Results
        </InertiaLink>

        <button
          className={classNames(
            "cursor-pointer rounded-sm p-3 lg:group-hover:bg-black",
            {
              "bg-primary group-hover:bg-primary": isActive,
            },
          )}
          onClick={handleToggleDropdown}
        >
          <ChevronDown
            className={`transition-all ${isOpen ? "rotate-180" : ""}`}
          />
        </button>
      </div>

      {isOpen && (
        <>
          <InertiaLink
            className={classNames(
              "rounded-sm px-4 py-2 text-base leading-[137%] hover:bg-black",
              {
                "bg-primary group-hover:bg-primary":
                  url.startsWith(`/inventory`),
              },
            )}
            href={route("emissions.inventory.setup")}
            onClick={closeMobileNavigation}
          >
            Emission inventory
          </InertiaLink>
          <span className="border-b border-[#535E63] px-4 py-1"></span>
        </>
      )}
    </>
  );
}
